import type { JSX } from "react";
import { FilterChip } from "../../Common";
import type { ScopedChild, ScopedChildKind } from "./scopeChildren";
export interface AnalyticLegendProps {
  readonly children: readonly ScopedChild[];
  readonly colors: readonly string[];
  readonly nextLevelName: ScopedChildKind;
  readonly onDrillInto: (childId: string) => void;
  readonly terminal: boolean;
  readonly metaFor?: (child: ScopedChild) => string;
}
export function AnalyticLegend({
  children,
  colors,
  onDrillInto,
  terminal,
  metaFor,
}: AnalyticLegendProps): JSX.Element {
  return (
    <ul className="analyticLegend">
      {children.map((child, index) => (
        <li key={child.id}>
          <FilterChip
            disabled={terminal}
            onClick={() => !terminal && onDrillInto(child.id)}
            aria-label={`Drill into ${child.title}`}
          >
            <span
              className="chipSwatch"
              style={{
                display: "inline-block",
                flex: "none",
                marginRight: "6px",
                background: colors[index],
              }}
            />
            <span className="chipTitle">{child.title}</span>
            {metaFor && (
              <>
                <span className="chipSeparator" style={{ marginLeft: "4px" }}>
                  {" · "}
                </span>
                <span className="chipMeta">{metaFor(child)}</span>
              </>
            )}
          </FilterChip>
        </li>
      ))}
      <style>{`.analyticLegend{display:flex;gap:7px;flex-wrap:wrap;padding:12px 0 0;margin:0;list-style:none}.chipSwatch{display:inline-block;flex:none;width:8px;height:8px;border-radius:50%;margin-right:6px}.chipSeparator{margin-left:4px;color:var(--text-muted)}.chipMeta{color:var(--text-muted)}`}</style>
    </ul>
  );
}
